import { BaseContainerModel } from '../../../base-container.model';
import {bl_del_vehicle_hdr_RowClass, bl_del_vehicle_ext_RowClass} from '../../../../dbschema';

export class VehicleDeliveryHeaderContainerModel extends BaseContainerModel {
  bl_del_vehicle_hdr: bl_del_vehicle_hdr_RowClass = new bl_del_vehicle_hdr_RowClass();
  bl_del_vehicle_ext: bl_del_vehicle_ext_RowClass[] = [];
}